module.exports = __webpack_public_path__ + "static/media/title_media.6a0bb11b.svg";